import LibPhoneNumber from 'google-libphonenumber';
const phoneUtil = LibPhoneNumber.PhoneNumberUtil.getInstance();
const PNF = LibPhoneNumber.PhoneNumberFormat;

export const formatNumber = (
  phoneNumber: string,
): { isValid: boolean; phoneNumber: string; countryCode: string | undefined } => {
  let number: LibPhoneNumber.PhoneNumber | null | undefined = null;
  let isValidNumber = false;
  try {
    number = phoneUtil.parse(phoneNumber);
    isValidNumber = phoneUtil.isValidNumber(number);
  } catch (e) {
    isValidNumber = false;
  }

  return {
    isValid: isValidNumber,
    phoneNumber: isValidNumber ? phoneUtil.format(number!, PNF.INTERNATIONAL) : phoneNumber,
    countryCode: isValidNumber ? phoneUtil.getRegionCodeForNumber(number!) : undefined,
  };
};

// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
export const countryToFlag = (isoCode: string | null | undefined) => {
  if (!isoCode) {
    return '❓';
  }

  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
};

export const getCodeFromNumber = (phoneNumber: string, countryCode: string) => {
  try {
    const number = phoneUtil.parse(phoneNumber, countryCode);
    return phoneUtil.getRegionCodeForNumber(number);
  } catch (error) {
    return undefined;
  }
};

export const matchCodeToPhone = (phoneNumber: string, countryCode: string) => {
  try {
    const number = phoneUtil.parse(phoneNumber, countryCode);
    const ccode = number.getCountryCode();

    if (!phoneUtil.isValidNumberForRegion(number, countryCode)) {
      return false;
    }

    if (phoneNumber.includes(`+${ccode}`)) {
      return false;
    }

    if (phoneNumber.slice(0, ccode!.toString().length).includes(ccode!.toString())) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};
